export const sponsors = [
    {
        name: "Armatec",
        logo: "/photos/sponsors/armatec.png",
        url: "https://www.armateconline.com/",
        tier: "Hypersonic",
        location: "London, Ontario",
        description: "Advanced manufacturing solutions and precision tooling for aerospace applications"
    },
    {
        name: "Schaeffler",
        logo: "/photos/sponsors/schaeffler.png",
        url: "https://www.schaeffler.com/en/",
        tier: "Hypersonic",
        location: "Herzogenaurach, Germany", 
        description: "Global automotive and industrial supplier specializing in motion technologies"
    },
    {
        name: "Diamond Aircraft",
        logo: "/photos/sponsors/diamond.png",
        url: "https://www.diamondaircraft.com/en/",
        tier: "Hypersonic",
        location: "London, Ontario",
        description: "Leading manufacturer of composite aircraft and flight training solutions"
    },
    // {
    //     name: "Air Canada",
    //     logo: "/photos/sponsors/aircanada.png",
    //     url: "https://www.aircanada.com/home/ca/en/aco/flights",
    //     tier: "Hypersonic",
    //     location: "Montreal, Quebec",
    //     description: "Leading Canadian airline offering domestic and international flights"
    // },
    {
        name: "Western University",
        logo: "/photos/sponsors/western.png",
        url: "https://www.uwo.ca/index.html",
        tier: "Hypersonic",
        location: "London, Ontario",
        description: "We combine research excellence with a transformational student experience to create a meaningful impact in our communities and beyond."
    },
    {
        name: "Western Engineering",
        logo: "/photos/sponsors/westernengineering.png",
        url: "https://www.eng.uwo.ca/index.html",
        tier: "Supersonic",
    },
    {
        name: "Trackunit",
        logo: "/photos/sponsors/trackunit.png",
        url: "https://trackunit.com/",
        tier: "Supersonic",
    },
    {
        name: "Siemens",
        logo: "/photos/sponsors/siemens.jpg",
        url: "https://www.siemens.com/ca/en.html",
        tier: "Supersonic",
    },
    {
        name: "London Model Aircraft Club",
        logo: "/photos/sponsors/lmac.gif",
        url: "https://lmac.ca/",
        tier: "Supersonic",
    },
    {
        name: "Why Design",
        logo: "/photos/sponsors/whydesign.png",
        url: "https://whydesign.ca/",
        tier: "Supersonic",
    },
    {
        name: "Solidworks",
        logo: "/photos/sponsors/solidworks.png",
        url: "https://www.solidworks.com/",
        tier: "Subsonic",
    },
    {
        name: "Amphenol",
        logo: "/photos/sponsors/amphenol.png",
        url: "https://www.amphenol.com/",
        tier: "Subsonic",
    },
    {
        name: "Undergraduate Engineering Society",
        logo: "/photos/sponsors/ues.png",
        url: "https://www.western-ues.com/",
        tier: "Subsonic",
    },
    {
        name: "University Students' Council",
        logo: "/photos/sponsors/usc.png",
        url: "https://westernusc.ca/",
        tier: "Subsonic",
    },
];